<template>
  <div class="my_attention">
    <div class="header">
        <div class="header_left">我的关注（n）</div>
        <div class="header_left">
            <a-button type="primary">浏览时间</a-button>
            <a-button type="primary">更新时间</a-button>
        </div>
        </div> 
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>